export const REMINDER_TIME_OPTIONS = {
    'Morning (09:00 AM EST)': 'Morning(09:00 AM)',
    'Morning (10:00 AM EST)': 'Morning(10:00 AM)',
    'Morning (11:00 AM EST)': 'Morning(11:00 AM)',
    'Afternoon (12:00 PM EST)': 'Afternoon(12:00 PM)',
    'Afternoon (01:00 PM EST)': 'Afternoon(01:00 PM)',
    'Afternoon (02:00 PM EST)': 'Afternoon(02:00 PM)',
    'Afternoon (03:00 PM EST)': 'Afternoon(03:00 PM)',
    'Afternoon (04:00 PM EST)': 'Afternoon(04:00 PM)',
    'Afternoon (05:00 PM EST)': 'Afternoon(05:00 PM)',
    'Evening (06:00 PM EST)': 'Evening(06:00 PM)',
    'Evening (07:00 PM EST)': 'Evening(07:00 PM)',
    'Evening (08:00 PM EST)': 'Evening(08:00 PM)',
    'Evening (09:00 PM EST)': 'Evening(09:00 PM)',
};
